import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';
import { CompanyInfoModalProps } from '../../../type';
import CompanyInfoModal from './company-info-modal';

const CompanyInfoModalContainer: React.FC<CompanyInfoModalProps> = ({
  addChatMessage,
  saveCurrentStepDetails,
}) => {
  const {
    data: { companyInfo },
  } = useSelector((state: RootState) => state?.sequence?.generateAiSeqModal);

  const stepRequestStatus = useSelector(
    (state: RootState) =>
      state?.sequence?.saveAiSeqGeneratorStepDetailsRequest?.status,
  );

  return (
    <CompanyInfoModal
      companyInfo={companyInfo}
      addChatMessage={addChatMessage}
      stepRequestStatus={stepRequestStatus}
      saveCurrentStepDetails={saveCurrentStepDetails}
    />
  );
};

export default memo(CompanyInfoModalContainer);
